"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
/* eslint-disable max-lines-per-function */
const analytics_1 = require("@completeanatomy/analytics");
const bridge_schema_1 = require("@completeanatomy/bridge-schema");
const StructureClusterNames_1 = require("../../atoms/StructureClusterNames");
const hooks_1 = require("../../hooks");
const InfoboxMenu_1 = require("../../molecules/InfoboxMenu");
const PanelMenu_1 = __importDefault(require("../../molecules/PanelMenu"));
const react_1 = require("react");
const styled_components_1 = __importDefault(require("styled-components"));
const ButtonActionToolbar_1 = __importDefault(require("../ButtonActionToolbar"));
const InfoboxDescriptionPanel_1 = __importDefault(require("../InfoboxDescriptionPanel"));
const MultiSelectionTabGrasshopper_1 = require("../MultiSelectionTabGrasshopper");
const SlideOutPanel_1 = __importDefault(require("../SlideOutPanel"));
const ViewControls_1 = __importDefault(require("../ViewControls"));
function DesktopInfoboxPanel({ audio, currentTab, information, isDescriptionPanelOpen, isOpenInfoboxMenu, isSidePanelOpen, isSpotPanelOpen, items, names, setIsSidePanelOpen, onItemClick, setCurrentTab, setIsOpenInfoboxMenu, setIsOverlayOpened, }) {
    const buttonRef = (0, react_1.useRef)(null);
    const [selectedItemViewControl, setSelectedViewControl] = (0, react_1.useState)();
    (0, hooks_1.useSelectInfoBoxTab)(currentTab);
    const infoboxHeaderRef = (0, react_1.useRef)(null);
    const [infoboxHeaherHeight, setInfoboxHeaderHeight] = (0, react_1.useState)(200);
    const analytics = (0, analytics_1.useAnalytics)();
    const { isActive: isMultiSelectActive } = (0, hooks_1.useMultiSelectState)();
    const onClose = (0, react_1.useCallback)(() => {
        setIsSidePanelOpen(false);
    }, [setIsSidePanelOpen]);
    const onClickMinimise = (0, react_1.useCallback)(() => {
        analytics.log('collapse_infobox_pressed', {
            name: 'infobox' + (currentTab ? '_minimized' : '_maximized'),
            accessLocation: analytics_1.AnalyticsAccessLocation.Infobox,
        });
        if (isOpenInfoboxMenu) {
            setIsOpenInfoboxMenu(false);
            setCurrentTab(bridge_schema_1.InfoBoxTabType.None);
            setIsSidePanelOpen(false);
        }
        else {
            setIsOpenInfoboxMenu(true);
        }
    }, [
        analytics,
        currentTab,
        isOpenInfoboxMenu,
        setCurrentTab,
        setIsOpenInfoboxMenu,
        setIsSidePanelOpen,
    ]);
    (0, react_1.useEffect)(() => {
        if (infoboxHeaderRef.current) {
            setInfoboxHeaderHeight(infoboxHeaderRef.current.offsetHeight);
        }
    }, [isOpenInfoboxMenu, isMultiSelectActive, isSidePanelOpen]);
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(Infobox, { ref: buttonRef, "data-e2e": 'DesktopInfoboxPanel_Infobox', children: isMultiSelectActive ? ((0, jsx_runtime_1.jsx)(MultiSelectionTabGrasshopper_1.MultiSelectionTabGrasshopper, { selectedItemViewControl: selectedItemViewControl, setSelectedViewControl: setSelectedViewControl, "data-e2e": 'DesktopInfoboxPanel_MultiSelectionTabGrasshopper' })) : ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsxs)("div", { ref: infoboxHeaderRef, "data-e2e": 'DesktopInfoboxPanel_div', children: [(0, jsx_runtime_1.jsx)(StructureClusterNames_1.StructureClusterNames, { firstName: (names === null || names === void 0 ? void 0 : names.english) || '', secondaryName: (names === null || names === void 0 ? void 0 : names.latin) || '', isCentered: false, "data-e2e": 'DesktopInfoboxPanel_StructureClusterNames' }), (0, jsx_runtime_1.jsx)(ViewControls_1.default, { selectedItemViewControl: selectedItemViewControl, setSelectedViewControl: setSelectedViewControl, "data-e2e": 'DesktopInfoboxPanel_ViewControls' }), (0, jsx_runtime_1.jsx)(ButtonActionToolbar_1.default, { onClose: () => { }, audioFile: audio, alternativeNames: names === null || names === void 0 ? void 0 : names.alternative, name: names === null || names === void 0 ? void 0 : names.title, isSelectedMinimise: !isOpenInfoboxMenu, onClickMinimise: onClickMinimise, "data-e2e": 'DesktopInfoboxPanel_ButtonActionToolbar' })] }), isOpenInfoboxMenu && ((0, jsx_runtime_1.jsx)(InfoboxMenuContainer, { "$isSidePanelOpen": isSidePanelOpen, "$infoboxHeaherHeight": infoboxHeaherHeight, "data-e2e": 'DesktopInfoboxPanel_InfoboxMenuContainer', children: (0, jsx_runtime_1.jsx)(InfoboxMenu_1.InfoboxMenu, { onItemClick: onItemClick, currentTab: currentTab, "data-e2e": 'DesktopInfoboxPanel_InfoboxMenu' }) }))] })) }), (0, jsx_runtime_1.jsxs)(SlideOutPanel_1.default, { currentTab: currentTab, isOpen: isSidePanelOpen, setCurrentTab: setCurrentTab, "data-e2e": 'DesktopInfoboxPanel_SlideOutPanel', children: [(0, jsx_runtime_1.jsx)(InfoboxDescriptionPanel_1.default, { isOpen: isDescriptionPanelOpen, onClose: onClose, descriptionText: information || '', "data-e2e": 'DesktopInfoboxPanel_InfoboxDescriptionPanel' }), (0, jsx_runtime_1.jsx)(PanelMenu_1.default, { isOpen: isSpotPanelOpen, onClose: onClose, activeTab: currentTab, setIsOverlayOpened: setIsOverlayOpened, items: items, "data-e2e": 'DesktopInfoboxPanel_PanelMenu' })] })] }));
}
exports.default = DesktopInfoboxPanel;
const InfoboxMenuContainer = styled_components_1.default.div `
  position: relative;
  width: 200px;
  overflow-y: auto;
  overflow-x: hidden;
  position: relative;
  transition: min-height 0.8s ease-out;
  min-height: ${({ $isSidePanelOpen, $infoboxHeaherHeight }) => $isSidePanelOpen
    ? `calc((100vh - ${$infoboxHeaherHeight}px) - 185px)`
    : '0'};

  &::-webkit-scrollbar {
    width: 8px;
  }

  &::-webkit-scrollbar-track {
    background-color: ${({ theme }) => theme.grasshopper.background};
  }

  &::-webkit-scrollbar-thumb {
    background-color: ${({ theme }) => theme.grasshopper.descriptionPanel.scroll.idle};
    border-radius: 6px;
  }

  &::-webkit-scrollbar-thumb:hover {
    opacity: 0.8;
  }
`;
const Infobox = styled_components_1.default.div `
  position: relative;
  top: 8px;
  padding: 4px;
  padding-left: 8px;
  display: flex;
  flex-direction: column;
  padding: 16px 8px;
  background-color: ${({ theme }) => theme.grasshopper.background};
  border-radius: 4px;
  width: 200px;
  max-height: calc(100vh - 172px);
  gap: 16px;

  z-index: 1;
`;
